import ai_light from "../assets/vendAI_light.png";
import ai_dark from "../assets/vendAI_dark.png";
import vendaiFavicon from "../assets/favicon.ico";
import { API_HOST, UI_HOST, KEYCLOAK_HOST, KEYCLOAK_UITEST_HOST } from "../config/api";

const DEFAULT_TEXT_STYLE = {
  fontWeight: "bold",
  fontSize: "2rem",
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: "text.primary",
};

export const TENANTS = {
  "vendai.lettaiot.com": {
    title: "VendAI",
    projectCode: "VENDAI",
    favicon: vendaiFavicon,
    theme: {
      primary: "#F5F5F7",
      logoLight: ai_light,
      logoDark: ai_dark,
    },
    apiBaseUrl: UI_HOST,
    keycloakHost: KEYCLOAK_HOST,
  },
  "vendbox.lettaiot.com": {
    name: "VAOYS",
    title: "VAOYS",
    projectCode: "VAOYS",
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: UI_HOST,
    keycloakHost: KEYCLOAK_HOST,
  },
  "wwms.lettaiot.com": {
    name: "WWMS",
    title: "WWMS",
    projectCode: "WWMS",
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: API_HOST,
    keycloakHost: KEYCLOAK_HOST,
  },
  "uitest.lettaiot.com": {
    name: "VendAI Otomat Yönetim Sistemi",
    title: "VendAI Otomat Yönetim Sistemi",
    projectCode: "VAOYS",
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: API_HOST,
    keycloakHost: KEYCLOAK_UITEST_HOST,
  },
  default: {
    name: "VendAI Test",
    title: "VendAI Test",
    projectCode: "VAOYS",
    theme: {
      primary: "#F5F5F7",
    },
    apiBaseUrl: API_HOST,
    keycloakHost: KEYCLOAK_UITEST_HOST,
  },
};

export const TENANT_PATH_CONFIG = {
  VAOYS: "vending-machines",
  VENDAI: "vending-machines",
  WWMS: "places",
  DEFAULT: "vending-machines",
};

/**
 * Get current tenant configuration based on hostname
 * @returns {Object} Tenant configuration
 */
export const getCurrentTenant = () => {
  const hostname = window.location.hostname;

  let tenant;

  if (TENANTS[hostname]) {
    tenant = TENANTS[hostname];
  } else if (hostname.endsWith(".lettaiot.com")) {
    const subdomain = hostname.split(".")[0];
    tenant = {
      name: subdomain.toUpperCase(),
      projectCode: subdomain.toUpperCase(),
      theme: {
        primary: "#1976d2",
      },
      apiBaseUrl: API_HOST,
      keycloakHost: KEYCLOAK_HOST,
    };
  } else {
    tenant = TENANTS["default"];
  }

  return { textStyle: DEFAULT_TEXT_STYLE, ...tenant };
};
